import { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  campaignsPlainSelector,
  campaignsSelectorFactory,
  campaignStateChangeTimestampSelector,
} from './selectors';
import { getClosestCampaignStateTimestamp } from './utils';
import {
  fetchCampaignsIfNeeded,
  setCampaignStateChangeTimestamp,
} from './slice';

export const useCampaignStateAutoUpdate = () => {
  const dispatch = useDispatch();
  const { items: campaigns } = useSelector(campaignsPlainSelector);
  const closestCampaignStateChange = useSelector(
    campaignStateChangeTimestampSelector,
  );
  const campaignsRef = useRef([]);
  useEffect(() => {
    campaignsRef.current = campaigns;
  }, [campaigns]);

  useEffect(() => {
    const updateClosestCampaignStateChange = () => {
      const closest = getClosestCampaignStateTimestamp(campaignsRef.current);
      dispatch(setCampaignStateChangeTimestamp(closest));
    };

    let timeoutId;
    if (closestCampaignStateChange > Date.now()) {
      timeoutId = setTimeout(() => {
        updateClosestCampaignStateChange();
      }, closestCampaignStateChange - Date.now() + 500);
    } else {
      updateClosestCampaignStateChange();
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [closestCampaignStateChange, dispatch]);
};

export const useBundleCampaign = ({ _id, currency, lootBundles }) => {
  const dispatch = useDispatch();
  const campaignSelector = useMemo(
    () =>
      campaignsSelectorFactory({
        lootId: _id,
        currency,
        lootBundles,
      }),
    [_id, currency, lootBundles],
  );

  useEffect(() => {
    dispatch(fetchCampaignsIfNeeded()).catch(() => {});
  }, [dispatch]);

  return useSelector(campaignSelector);
};
